<template>
  <div class="page declaration-page">
    <div class="container" v-if="declaration">
      <img class="alvariza-logo mt-3" src="@/declaration/logo.jpg" />

      <h1 class="mt-1 mb-3">
        DECLARACIÓN DE PERTENENCIA AL GRUPO DE CERTIFICACIÓN FORESTAL ALVARIZA
      </h1>

      <h2>
        ENXEÑERIA FORESTAL ASEFOR S.L , gestor del grupo ALVARIZA Declara por el
        presente documento
      </h2>

      <p class="mt-3">
        Las parcelas detalladas en este certificado, y gestionadas por
        {{ declaration.fullname }} con CIF {{ declaration.vat_number }}, dirección
        {{ declaration.full_address }} y municipio
        {{ declaration.municipality_name }}
      </p>

      <p class="mt-3" v-if="declaration.certifications">{{ certificationText }}</p>

      <table class="table is-bordered is-fullwidth mt-3">
        <tbody>
          <tr class="first">
            <th>Subcódigo Certificado MIEMBRO ALVARIZA</th>
            <td>
              {{ selectedCert.code }}
            </td>
          </tr>

          <tr class="last">
            <th>Hasta</th>
            <td>
              <p>{{ selectedCert.validate_date | localize }}</p>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="warning">
        ESTE DOCUMENTO NO SIRVE PARA LA ACREDITACIÓN DE MADERA CERTIFICADA. SOLICITAR AL
        GRUPO ALVARIZA EL INFORME DE ACREDITACIÓN DE MADERA CERTIFICADA AL FINALIZAR EL
        APROVECHAMIENTO
      </p>

      <table class="table is-bordered is-fullwidth mt-4">
        <thead>
          <tr>
            <th>REFERENCIA CATASTRAL</th>
            <th>DESDE</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="parcel in selectedParcels" :key="parcel.id">
            <td>{{ parcel.parcel.cadastral_ref }}</td>
            <td>{{ parcel.service_request.certification_record_date | localize }}</td>
          </tr>
        </tbody>
      </table>

      <div id="footer">
        <div id="sign-block">
          <img id="signature" src="@/declaration/firma.jpg" />

          <div>
            <p><b>Firma Representante Grupo ALVARIZA</b></p>
            <p>Santiago de compostela &nbsp;</p>
            <p>{{ documentDatetime() }}</p>
          </div>

          <img id="cert-logo" :src="require(`@/declaration/${certificationLogo}`)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api"

export default {
  name: "declaration",
  mounted() {
    if (!this.$_.includes(["FSC", "PEFC"], this.type)) {
      this.$router.push({ name: "home" })
    }

    this.getDeclarationData()
    this.getParcels()
  },
  computed: {
    certificationLogo() {
      if (this.$route.params.type === "FSC") {
        return "logo_fsc.jpeg"
      }

      return "logo_pefc.png"
    },
    selectedCert() {
      if (!this.declaration || !this.declaration.certifications) {
        return {}
      }

      return this.declaration.certifications[this.$route.params.type]
    },
    selectedParcels() {
      if (!this.parcels) {
        return []
      }

      const types = [this.$route.params.type, "DOUBLE"]
      return this.parcels.filter((parcel) => {
        return (
          this.$_(types, parcel.certification_type) &&
          parcel.service_request.certification_record_date
        )
      })
    },
    certificationText() {
      const certs = this.declaration.certifications

      if (this.$route.params.type === "FSC") {
        return `
        Pertenece al Grupo de Certificación Forestal ALVARIZA,
        que se encuentra certificado por SCS Global Services,
        bajo los requisitos de los estándares españoles de gestión forestal
        para la certificación FSC-STD-ESP-2006-01-ESP (V 1.2),
        con código de certificación: ${certs.FSC.prefix}
        `
      }

      // PEFC
      return `
      Pertenece al Grupo de Certificación Forestal ALVARIZA, que se encuentra
        certificado por AENOR, bajo los requisitos de los estándares españoles
        de gestión forestal para la certificación UNE 162002-1:2007 y con el
        Sistema Español de Certificación de la Gestión Forestal Sostenible de
        PEFC, con código de certificación: ${certs.PEFC.prefix}
      `
    },
    type() {
      return this.$route.params.type
    },
  },
  data: () => ({
    declaration: {},
    parcels: [],
  }),
  methods: {
    documentDatetime() {
      const format = "DD/MM/YYYY HH:mm"
      return this.$moment(new Date()).format(format)
    },
    getDeclarationData() {
      const url = "bikenta/declaration-data"
      api._get(url).then((response) => {
        this.declaration = response.data
      })
    },
    getParcels() {
      const url = "bikenta/service-request-parcels/?page_size=9999"
      api._get(url).then((response) => {
        this.parcels = response.data.results
      })
    },
  },
}
</script>
